import { TypeKinship } from '../shared/enums/type-kinship.enum';

export class EnumUtils {
	static getEnumValue<T extends Record<string, unknown>>(
		enumClass: T,
		value: unknown,
	): T[keyof T] | undefined {
		if (typeof value == 'number') {
			return this.getEnumValue(enumClass, value.toString());
		} else if (typeof value == 'string') {
			const enumEntries = Object.entries(enumClass) as [keyof T, T[keyof T]][];
			let enumEntry = enumEntries.find(([key]) => {
				return key.toString() === value;
			});

			if (enumEntry) {
				return enumEntry[1];
			} else {
				enumEntry = enumEntries.find(([, entry]) => {
					return (entry as any).toString() === value;
				});

				return (
					enumEntry ? (enumEntry[0].toString() as any) : undefined
				) as T[keyof T];
			}
		} else {
			return undefined;
		}
	}

	static getKinship(kinship?: string): string | undefined {
		if (!kinship) return undefined;

		switch (kinship) {
			case 'TITULAR':
				return 'Titular';
			case 'CONJUGE':
				return 'Cônjuge';
			case 'FILHO':
				return 'Filho';
			case 'ENTEADO':
				return 'Enteado';
			case 'PAI_MAE':
				return 'Pai / Mãe';
			case 'NETO':
				return 'Neto';
			case 'IRMAO':
				return 'Irmão';
			case 'AVO':
				return 'Avô / Avó';
			case 'TIO':
				return 'Tio / Tia';
			case 'SOBRINHO':
				return 'Sobrinho';
			case 'BISNETO':
				return 'Bisneto';
			case 'SOGRO':
				return 'Sogro';
			case 'GENRO_NORA':
				return 'Genro / Nora';
			case 'PADRASTO_MADRASTA':
				return 'Padrasto / Madrasta';
			default:
				throw new Error(
					`Valor '${kinship}' nao corresponde à enum TypeKinship`,
				);
		}
	}

	static getKinshipFromNumberValue(kinship: number | string): TypeKinship {
		const value = kinship.toString();

		switch (value) {
			case '1':
				return TypeKinship.CONJUGE;
			case '2':
				return TypeKinship.FILHO;
			case '3':
				return TypeKinship.ENTEADO;
			case '4':
				return TypeKinship.PAI_MAE;
			case '5':
				return TypeKinship.NETO;
			case '6':
				return TypeKinship.IRMAO;
			case '7':
				return TypeKinship.AVO;
			case '8':
				return TypeKinship.TIO;
			case '9':
				return TypeKinship.SOBRINHO;
			case '10':
				return TypeKinship.BISNETO;
			case '11':
				return TypeKinship.SOGRO;
			case '12':
				return TypeKinship.GENRO_NORA;
			case '13':
				return TypeKinship.PADRASTO_MADRASTA;
			default:
				throw new Error(`Valor '${value}' nao corresponde à enum TypeKinship`);
		}
	}

	static getKinshipNumericValue(value: TypeKinship): string {
		switch (value) {
			case TypeKinship.CONJUGE:
				return '1';
			case TypeKinship.FILHO:
				return '2';
			case TypeKinship.ENTEADO:
				return '3';
			case TypeKinship.PAI_MAE:
				return '4';
			case TypeKinship.NETO:
				return '5';
			case TypeKinship.IRMAO:
				return '6';
			case TypeKinship.AVO:
				return '7';
			case TypeKinship.TIO:
				return '8';
			case TypeKinship.SOBRINHO:
				return '9';
			case TypeKinship.BISNETO:
				return '10';
			case TypeKinship.SOGRO:
				return '11';
			case TypeKinship.GENRO_NORA:
				return '12';
			case TypeKinship.PADRASTO_MADRASTA:
				return '13';
			default:
				throw new Error(`Valor '${value}' nao corresponde à enum TypeKinship`);
		}
	}
}
